import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Modal from "react-modal";

import "../App.css";
import Float from "./Float.js";

const Inicio = () => {
  const [modal_is_open, modal_is_open_update] = useState(false);
  const [modal_is_open_2, modal_is_open_update_2] = useState(false);
  const history = useHistory();
  return (
    <div className="container_portada">
      <Float></Float>

      <Modal
        isOpen={modal_is_open}
        onRequestClose={() => modal_is_open_update(false)}
        style={{
          content: {
            padding: "0",
            margin: "auto",
            top: "5px",
            right: "5px",
            bottom: "5px",
            left: "5px",
            borderRadius: "15px",
            maxWidth: "450px",
            maxHeight: "900px",
            zIndex: "5",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          },
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "20px",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_1.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                100% Natural
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Todos nuestros productos son completamente naturales, sin
                aditivos, saborizantes o colorantes de ningún tipo. La mayoría,
                incluso, están creados con un solo ingrediente.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_2.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Alto en Colágeno
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Es el componente principal de los tejidos conectivos que
                conforman varias partes del cuerpo, incluyendo los tendones, los
                ligamentos, la piel y los músculos. El colágeno desempeña muchas
                funciones importantes, como proporcionar estructura a la piel y
                fortalecer los huesos.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_3.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Alto en Omega 3 y 6
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Son un tipo de grasa poliinsaturada que necesitamos para
                fortalecer las neuronas y para otras funciones importantes.
                Ayudan a mantener el corazón sano y protegido contra un
                accidente cerebrovascular, previenen el cáncer y tienen efectos
                antidepresivos.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_4.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Alto en proteínas
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                No solo ayuda a prevenir la degradación muscular, sino que
                también puede ayudar a desarrollar y fortalecer los músculos. La
                combinación de ejercicio regular con un alto consumo de
                proteínas promueve el crecimiento muscular y el fortalecimiento.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_5.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Alto en Glucosamina
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Es una de las sustancias del cuerpo que se utiliza para formar
                cartílago. Ayuda a regenerar las articulaciones y que se muevan
                con mayor suavidad. Es especialmente importante para perros que
                ya no están en la etapa de la juventud.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_6.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Limpia Dientes
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Los productos que veas con este símbolo sirven para limpiar
                dientes y eliminar el zarro de la dentadura de forma muy eficaz.
                La limpieza bucal en perros es necesaria para evitar que las
                bacterias se adhieran a la superficie de los dientes tras las
                comidas.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_7.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Fortalece la Mandíbula
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Ya sea debido al Colágeno o a la necesidad de morder los Snacks,
                muchos de nuestros productos ayudan a fortalecer la mandíbula y
                evitar que esté inactiva por mucho tiempo.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <img
              style={{
                width: "70px",
                height: "70px",
                margin: "20px 0px 0px 10px",
              }}
              src="/img/b_8.png"
              alt=""
            ></img>
            <div>
              <p
                style={{
                  fontSize: "17px",
                  margin: "20px",
                  opacity: "0.9",
                  textAlign: "start",
                  color: "black",
                }}
              >
                Libera ansiedad y estrés.
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px 20px 100px 20px",
                  textAlign: "justify",
                  opacity: "0.9",
                  fontStyle: "italic",
                }}
              >
                Un perro estresado suele sentirse incómodo ante una situación
                desconocida (como al encontrarse con otros perros) y hace que
                reaccione de una manera exagerada. Eso hará que intente huir o
                que reaccione de forma muy negativa. Por eso, es bueno
                entregarle Snacks que les libere tensión o hacer paseos largos
                en donde puedan liberar energía.
              </p>
            </div>
          </div>
        </div>
        <img
          className="close_button"
          src="/img/close.png"
          alt=""
          onClick={() => modal_is_open_update(false)}
        ></img>
      </Modal>

      <Modal
        isOpen={modal_is_open_2}
        onRequestClose={() => modal_is_open_update_2(false)}
        style={{
          content: {
            padding: "0",
            margin: "auto",
            top: "5px",
            right: "5px",
            bottom: "5px",
            left: "5px",
            borderRadius: "15px",
            maxWidth: "450px",
            maxHeight: "900px",
            zIndex: "5",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          },
        }}
      >
        <div>
          <div className="modal_info">
            <h1>Información</h1>
            <p>
              El despacho en Santiago tiene un costo de $2.990 y se realiza en 3
              días hábiles.
            </p>
            <p>
              El despacho a Regiones lo hacemos a través de Starken y te
              aparecerá el costo cuando selecciones tu comuna. Te llegará un
              código de seguimiento a tu correo para que veas el estado del
              despacho en todo momento.
            </p>
            <p>
              Tenemos un punto de retiro en Avenida el Cerro 1731, Providencia.
            </p>
            <p>
              El Jerky tiene una duración de 2 años cerrados y 3 meses una vez
              abiertos. Los demás productos tienen una duración de 2 años,
              independiente si la mascota comenzó a comerlos o no. A veces
              nuestros perros los pueden enterrar y guardarlos para después, ¡no
              hay ningún problema con eso!
            </p>
          </div>
        </div>
        <img
          className="close_button"
          src="/img/close.png"
          alt=""
          onClick={() => modal_is_open_update_2(false)}
        ></img>
      </Modal>

      <div className="portada_fija">
        <img src="/img/portada13.jpg" alt=""></img>
        <div className="frase">
          <p>Tu Mascota más feliz con Snacks 100% Naturales</p>
        </div>
      </div>

      <div className="portada_casilla">
        <img src="/img/portada14.jpg" alt=""></img>
        <div>
          <h1>Descubre los beneficios de los Snacks Cornerdog</h1>
          <p onClick={() => modal_is_open_update(true)}>Beneficios</p>
        </div>
      </div>

      <div className="portada_casilla">
        <img src="/img/portada8.jpg" alt=""></img>
        <div>
          <h1>¡Más de 15 productos naturales!</h1>
          <p
            onClick={() => window.open("https://ventu.cl/cornerdog", "_blank")}
          >
            Productos
          </p>
        </div>
      </div>

      <div className="portada_casilla">
        <img src="/img/portada17.jpg" alt=""></img>
        <div>
          <h1>Información sobre despacho y otros</h1>
          <p onClick={() => modal_is_open_update_2(true)}>Info</p>
        </div>
      </div>

      <div className="portada_casilla">
        <img src="/img/portada15.jpg" alt=""></img>
        <div>
          <h1>Aprende sobre las razas</h1>
          <p onClick={() => history.push("/razas")}>Razas</p>
        </div>
      </div>

      <div className="portada_casilla">
        <img src="/img/portada16.jpg" alt=""></img>
        <div>
          <h1>¿Tienes dudas? ¡Escríbenos!</h1>
          <p
            onClick={() =>
              window.open(
                "https://api.whatsapp.com/send/?phone=56966564743&text&app_absent=0",
                "_blank"
              )
            }
          >
            Whatsapp
          </p>
        </div>
      </div>

      <div className="footer">
        <img src="/img/logo1.png" alt=""></img>
      </div>
    </div>
  );
};

export default Inicio;
